import { render, staticRenderFns } from "./emailWelcome.vue?vue&type=template&id=56bdf738&"
import script from "./emailWelcome.vue?vue&type=script&lang=js&"
export * from "./emailWelcome.vue?vue&type=script&lang=js&"
import style0 from "./emailWelcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports